import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Activity from './Activity'

export default class Activities extends Component {
  render() {
    const { activities } = this.props
    var activitiesList = activities.map(function (activity, index) {
      return <Activity activity={activity} index={index} key={index} />
    })

    return <ul className="activities-list">{activitiesList}</ul>
  }
}

Activities.propTypes = {
  activities: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/menu/Activities.js